import { useEffect, useContext } from 'react';
import { AuthContext } from '../../logic';

const useTabSync = (): void => {
	const { uid } = useContext(AuthContext);

	useEffect(() => {
		window.addEventListener('storage', () => {
			const data = localStorage.getItem('user_data');
			const userId = data && JSON.parse(data).uid;

			if (userId !== uid) location.reload();
		});
	});
};

export { useTabSync };
